<div class="control-navigator" *ngIf="content && content.title">
  <div class="control-label">{{content.label}}</div>
  <div class="section-name subtitle-2">{{content.title}}</div>
  <a (click)="navigate(content.url)" class="redirect">{{content.buttonText}}<mat-icon>arrow_forward</mat-icon></a>
</div>
